import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseClassic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMouseClassic"><Path d="M5.5 9C5.5 5.41015 8.41015 2.5 12 2.5C15.5899 2.5 18.5 5.41015 18.5 9V15C18.5 18.5899 15.5899 21.5 12 21.5C8.41015 21.5 5.5 18.5899 5.5 15V9Z" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M12 2.5V9.5" stroke="currentColor"/><Path d="M5.75 9.5H18.25" stroke="currentColor"/></CentralIconBase>;
});

export default IconMouseClassic;
